module.exports = __webpack_public_path__ + "media/assets/images/patient-blue-ffd7ceeb6a851d23af7f4f7f5caed04e.svg";